import { useLingui } from "@lingui/react";
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AppDialog } from "@/components/common/AppDialog";

interface DeleteSelectedDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  selectedCount: number;
  isPending?: boolean;
}

export function DeleteSelectedDialog({
  open,
  onOpenChange,
  onConfirm,
  selectedCount,
  isPending = false,
}: DeleteSelectedDialogProps) {
  const { i18n } = useLingui();

  const title =
    selectedCount === 1
      ? i18n._("Delete selected item?")
      : i18n._("Delete selected items?");

  const description =
    selectedCount === 1
      ? i18n._(
          "This item will be permanently deleted. This action cannot be undone.",
        )
      : i18n._(
          "These items will be permanently deleted. This action cannot be undone.",
        );

  return (
    <AppDialog open={open} onOpenChange={onOpenChange} hideClose size="sm">
      <div className="flex flex-col items-center gap-4 py-4 text-center">
        <div className="flex size-20 items-center justify-center rounded-lg bg-(--color-danger)/10">
          <Trash2 className="size-10 text-(--color-danger-text)" />
        </div>

        <h3 className="text-lg font-semibold">{title}</h3>
        <p className="text-sm text-(--color-text-secondary)">{description}</p>

        <div className="flex w-full gap-3 pt-2">
          <Button
            variant="outline"
            className="flex-1"
            onClick={() => onOpenChange(false)}
          >
            {i18n._("Cancel")}
          </Button>
          <Button
            variant="destructive"
            className="flex-1"
            onClick={onConfirm}
            disabled={isPending}
          >
            {i18n._("Delete")}
          </Button>
        </div>
      </div>
    </AppDialog>
  );
}
